import gql from 'graphql-tag';

export default gql`
    query GetConversationById($input: ConversationByIdInput, $offset: Int) {
        getConversationById(input: $input, offset: $offset) {
            messageId
            conversationId
            creationDate
            conversationName
            isFromDriver
            loadId
            isGrupal
            lastMessageRead
            id
            driver {
                id
                name
                driverCompanyName
            }
            message {
                id
                creationDate
                bodyMessage
                messageType
            }
            totalCount
        }
    }
`;
